import './_styles.scss';
import React from 'react';
import Voucher from './_promo';
import Summary from './_summary';
import ProductList from './_products';
import { connect } from 'react-redux';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { actions, selectors } from 'redux-store';

const Content = ({ voucher=0, cart=[], data={}, total=0 }) => {

  const { delivery_method={} } = data;

  const delivery = delivery_method.charge || 0;

  const net_amount = ((total + delivery) - voucher);

  const toggle = () => document.getElementById('checkout-summary').classList.toggle('open');

  return (
    <div id='checkout-summary' className='Checkout-Products'>
      <div className="Wrapper">

        <ProductList data={cart}/>

        <Voucher onValidate={() => {}}/>

        <div className="Order-Summary">
          <Summary caption='Subtotal' value={total}/>
          <Summary caption='Delivery' value={delivery}/>
          <Summary caption='Discount' value={voucher}/>
          <Summary caption='Total' value={net_amount} total/>
        </div>

      </div>

      <div className="toggle-view" onClick={toggle}>
        <MdKeyboardArrowLeft className='icon'/>
        <span>Order Summary</span>
      </div>

    </div>
  )
}

const mapStateToProps = ({ cart }) => ({
  cart: cart.cart_items,
  total: selectors.cart_total(cart)
});

export default connect(mapStateToProps, {...actions})(Content);
